import appCONST from './../../../constants/app.constants';
import {ENDPOINTS} from './../../base/services/flightsApi';

const METHOD_POST = 'POST';

export default function FlightsInterceptorWrapper($httpProvider) {
    'ngInject';
    $httpProvider.interceptors.push(FlightsInterceptor);
}

function FlightsInterceptor(flightsService) {
    'ngInject';

    return {
        response: function(response) {
            return isResponseWithProducts(response)
                ? flightsService.decorateResponse(response)
                : response;
        },
    };

    function isResponseWithProducts(response) {
        const {config: {method, url}} = response;
        if (method !== METHOD_POST) {
            return false;
        }

        const requestedUrl = new URL(url);

        const endpointsForRetrievingProducts = [
            `${appCONST.apiUrl}${ENDPOINTS.flightSearchUrl}`,
            `${appCONST.apiUrl}${ENDPOINTS.flightFilterUrl}`,
            `${appCONST.apiUrl}${ENDPOINTS.eurostarSearchUrl}`,
            `${appCONST.apiUrl}${ENDPOINTS.eurostarFilterUrl}`,
        ];

        return endpointsForRetrievingProducts.includes(requestedUrl.href);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/services/flights.interceptor.js